/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import {
  Col,
  Row,
  Form,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
} from 'react-bootstrap';
import { CheckIcon } from '@heroicons/react/solid';

import { useBreakpoint } from '@vlinder-web/breakpoint-hook-widget-react';

export interface ISettingsCompProps {
  searchPlaceholderText?: string;
  searchStatusFilter?: {
    value: string;
    label: string;
  }[];
  typeOfSearch?: {
    value: string;
    label: string;
  }[];
  onSearchValue?(name: string): void;
  onStatusFilter?(value: string): void;
  settingsEntriesLabel?: string;
  onApplyFilter?(filterData: any, status: any): void;
  onClearFilter?(): void;
  applyLabel?: string;
  clearLabel?: string;
  typeStyle?: any;
  settingsEntries?: {
    value: string;
    label: string;
  }[];
  onSettingEntryChange(value: string): void;
}

export const SettingsAdminComp = ({
  searchPlaceholderText,
  searchStatusFilter,
  typeOfSearch,
  applyLabel,
  clearLabel,
  typeStyle,
  onSettingEntryChange,
  onApplyFilter,
  onClearFilter,
}: ISettingsAdminCompProps) => {
  const breakpoint = useBreakpoint();
  const [searchValue, setSearchValue] = useState('');
  const [statusFilter, setStatusFilter] = useState();
  const [settingEntry, setSettingEntry] = useState('10');
  const [typeFilter, setTypeFilter] = useState('');
  const [disableApply, setDisableApply] = useState(true);

  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
    setDisableApply(typeFilter === '' || e.target.value === '');
    // if (onSearchValue) {
    //   onSearchValue(newSearchValue?.toLowerCase());
    // }
  };

  const getButtonMargin = () => {
    let _style: any = {};
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      _style.marginTop = '15px';
    }
    return _style;
  };

  const changeTypeFilter = (e) => {
    console.log(`on change type`, e);
    const newTypeFilter = e.target.value;
    setTypeFilter(newTypeFilter);
    setDisableApply(searchValue === '' || e.target.value === '');
  };

  const _getStatus = (status: string) => {
    switch (status) {
      case 'active':
        return 'ACC_CREATED';
      case 'invited':
        return 'INVITED';
      case 'suspended':
        return 'SUSPENDED';
      default:
        return null;
    }
  };

  const applyFilterAction = () => {
    let _data: any = {};
    if (typeFilter && searchValue) {
      _data[typeFilter] = searchValue;
    }
    onApplyFilter && onApplyFilter(_data, statusFilter);
  };

  const changeStatusFilter = (e) => {
    console.log(`change value`, e.target.value);
    const newStatusFilter = e.target.value;
    setStatusFilter(newStatusFilter);
    setDisableApply(
      (typeFilter === '' || searchValue === '') && !newStatusFilter
    );
    // if (onStatusFilter) {
    //   onStatusFilter(newStatusFilter);
    // }
  };

  const changeSettingEntry = (e) => {
    setSettingEntry(e);
    if (onSettingEntryChange) {
      onSettingEntryChange(e);
    }
  };

  const clearFilter = () => {
    setSearchValue('');
    setStatusFilter(null);
    setDisableApply(true);
    onClearFilter && onClearFilter();
  };

  const _getCheckIcon = (value: any) => {
    if (value && value === settingEntry) {
      return <CheckIcon className="icon icon-xxs ms-auto" />;
    }
    return <></>;
  };

  return (
    <div className="table-settings mb-4" style={{ minWidth: '60%' }}>
      <Row className="justify-content-between align-items-center">
        <Col className="d-md-flex">
          <InputGroup className="me-2 me-lg-4 fmxw-500">
            <Form.Select
              value={typeFilter}
              style={typeStyle}
              // className="fmxw-150 d-none d-md-inline"
              onChange={changeTypeFilter}
            >
              <option value="">Select Type</option>
              {typeOfSearch?.map((status, index) => (
                <option
                  key={`option-${status?.value}-${index}`}
                  value={status?.value}
                >
                  {status?.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control
              type="text"
              placeholder={searchPlaceholderText}
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>
          <Form.Select
            value={statusFilter}
            className="fmxw-200 d-none d-md-inline"
            onChange={changeStatusFilter}
          >
            {searchStatusFilter?.map((status, index) => (
              <option
                key={`option-${status?.value}-${index}`}
                value={status?.value}
              >
                {status?.label}
              </option>
            ))}
          </Form.Select>
          <Button
            variant="secondary"
            size="sm"
            className="ms-3"
            disabled={disableApply}
            onClick={applyFilterAction}
            style={getButtonMargin()}
          >
            {applyLabel}
          </Button>
          {!disableApply ? (
            <Button
              variant="primary"
              size="sm"
              className="ms-3"
              onClick={clearFilter}
              style={getButtonMargin()}
            >
              {clearLabel}
            </Button>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

SettingsAdminComp.defaultProps = {
  searchPlaceholderText: 'Search users by Email',
  settingsEntriesLabel: 'Show',
  applyLabel: 'Apply',
  clearLabel: 'Clear',
  typeOfSearch: [
    {
      label: 'Email',
      value: 'email',
    },
  ],
  typeStyle: {
    maxWidth: '140px',
  },
};
